import { render, staticRenderFns } from "./WarnIcon.vue?vue&type=template&id=347bdec9"
import script from "./WarnIcon.vue?vue&type=script&lang=js"
export * from "./WarnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports